import { useEffect, useState } from 'react';

import { Device } from '@capacitor/device';
import { IonContent, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonPage, IonRow } from '@ionic/react';
import { createOutline, logInOutline, logOutSharp, pencilSharp, trashOutline, trashSharp } from 'ionicons/icons';
import { useAtomValue } from 'jotai';
import { DateTime } from 'luxon';

import packageInfo from '../../package.json';
import { Header } from '../components/Header';
import { useUser } from '../hooks/useSwr';
import { useResetAlert, usersWithTypeTextAtom } from '../utils/Global';

const Settings: React.FC = () => {
    const [deviceUUID, setDeviceUUID] = useState<string>('');
    const { user } = useUser();
    const { mainUser } = useAtomValue(usersWithTypeTextAtom);
    const handleResetAlert = useResetAlert();

    useEffect(() => {
        Device.getId().then((deviceID) => {
            setDeviceUUID(deviceID.identifier);
        });
    }, []);

    return (
        <IonPage>
            <Header title="Paramètres" />
            <IonContent fullscreen={true}>
                <div className="mt-10">
                    <IonList lines="full">
                        <div>
                            <IonItem className="m-0 p-0 bg-white">
                                <IonGrid className="bg-white mb-5 text-left">
                                    <IonRow>
                                        <IonLabel className="w-[87vw] text-2xl font-extrabold !truncate ...">
                                            {user?.name}
                                        </IonLabel>
                                    </IonRow>
                                    <IonRow>
                                        <IonLabel className="text-sm text-gray-500">Login: {user?.login}</IonLabel>
                                    </IonRow>
                                    <IonRow>
                                        <IonLabel className="text-sm text-gray-500">
                                            Rôle : {mainUser?.typeText}
                                        </IonLabel>
                                    </IonRow>
                                </IonGrid>
                            </IonItem>
                            <IonItem className="bg-white" onClick={handleResetAlert} button>
                                <IonIcon slot="start" ios={trashOutline} md={trashSharp} />
                                <IonLabel>Réinitialiser l'application</IonLabel>
                            </IonItem>

                            <IonItem className="bg-white" href="/reset">
                                <IonIcon slot="start" ios={createOutline} md={pencilSharp} />
                                <IonLabel>Modifier le mot de passe</IonLabel>
                            </IonItem>
                            <IonItem className="bg-white" href="/logout">
                                <IonIcon slot="start" ios={logInOutline} md={logOutSharp} color="danger" />
                                <IonLabel color="danger">Déconnexion</IonLabel>
                            </IonItem>
                        </div>
                    </IonList>
                </div>
                <div className="text-center text-xs text-gray-500 mt-10">
                    UUID : {deviceUUID}
                    <br />
                    Version {packageInfo.version}
                    <br />© {DateTime.now().year} {packageInfo.author}
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Settings;
